import { render, staticRenderFns } from "./StaticBenefitLineItem.vue?vue&type=template&id=5041648a&scoped=true"
import script from "./StaticBenefitLineItem.vue?vue&type=script&lang=ts"
export * from "./StaticBenefitLineItem.vue?vue&type=script&lang=ts"
import style0 from "./StaticBenefitLineItem.vue?vue&type=style&index=0&id=5041648a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041648a",
  null
  
)

export default component.exports